import { useEffect } from 'react';

interface ScrollManagerProps {
  currentPage: string;
}

function scrollToTopOrHash() {
  if (typeof window === 'undefined') return;

  const { hash } = window.location;

  // If we have a hash, try to scroll to the element
  if (hash && hash.length > 1) {
    const id = hash.slice(1);
    const el = document.getElementById(id);
    if (el) {
      // Prefer Lenis if available
      // @ts-expect-error - Lenis is a third-party library that may not be available
      if (window.lenis?.scrollTo) {
        // @ts-expect-error - Lenis scrollTo method
        window.lenis.scrollTo(el, { immediate: true });
      } else {
        el.scrollIntoView({ block: 'start' });
      }
      return;
    }
  }

  // No hash or element not found: scroll to top
  // @ts-expect-error - Lenis is a third-party library that may not be available
  if (window.lenis?.scrollTo) {
    // @ts-expect-error - Lenis scrollTo method
    window.lenis.scrollTo(0, { immediate: true });
  } else {
    window.scrollTo({ top: 0, left: 0 });
  }
}

export default function ScrollManager({ currentPage }: ScrollManagerProps) {
  // Disable browser scroll restoration so new pages don't inherit old scroll
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const { history } = window;
    if ('scrollRestoration' in history) {
      const prev = history.scrollRestoration;
      history.scrollRestoration = 'manual';
      return () => {
        history.scrollRestoration = prev;
      };
    }
  }, []);

  // Run on page change
  useEffect(() => {
    // Defer until after painting to avoid fighting other libs
    const id = requestAnimationFrame(scrollToTopOrHash);
    return () => cancelAnimationFrame(id);
  }, [currentPage]);

  return null;
}
